module.exports = __webpack_public_path__ + "img/Dantam Makeover 23.66b011f0.jpg";